import { apiClient } from '@/services/ApiClient.js'

export default {
  getBulkFarmerLimitApplications(query) {
    return apiClient
      .get('bulk-farmer-limit-applications', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createBulkFarmerLimitApplication(params) {
    let formData = new FormData()
    formData.append('file', params.file)
    if (params.retailer_id) {
        formData.append('retailer_id', params.retailer_id)
    }
    formData.append('description', params.description)
    return apiClient
      .postForm('bulk-farmer-limit-applications', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBulkFarmerLimitApplication(id) {
    return apiClient
      .get(`bulk-farmer-limit-applications/${id}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
